import { FiltersConfig } from '../../../../../../components/FilterGroup';

export const RANKING_TYPES_TABLE_FILTERS: FiltersConfig = {
  categoryId: {
    title: 'Ranking category',
    options: [],
  },
};
